module.exports = __webpack_public_path__ + "img/camera-retro-sharp-light.e4d99e71.svg";